export default function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-900 mb-2">关于我们</h2>
        <p className="text-sm text-foreground-500 mb-8">了解爱丫爱丫影院的初心与坚持</p>
        <div className="bg-background-100/70 rounded-lg p-6 md:p-10 border border-background-200/70">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed text-left max-w-2xl mx-auto">
            爱丫爱丫影院诞生于对纯粹观影体验的执着追求。在广告弹窗与漫长缓冲充斥的时代，我们决心打造一个极速高清、无广告不卡顿的免费观影空间。平台汇聚超过十万部电影与电视剧资源，覆盖动作、喜剧、爱情、悬疑、科幻等全品类内容，每日持续更新热门片源。无论是最新上映的大片，还是经典怀旧老片，你都能在这里找到并流畅观看。我们不设会员门槛、不插入任何广告，只希望每一位影迷都能回归观影本身——打开即看，畅快到底。
          </p>
          <div className="flex flex-wrap justify-center gap-6 md:gap-10 mt-8">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading text-primary-500">3年</div>
              <div className="text-xs text-foreground-500 mt-1">稳定运营</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading text-primary-500">500万+</div>
              <div className="text-xs text-foreground-500 mt-1">月活跃用户</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading text-primary-500">全时段</div>
              <div className="text-xs text-foreground-500 mt-1">不卡顿保障</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}